import { render, staticRenderFns } from "./pricingmanagement.vue?vue&type=template&id=51bd9c57&scoped=true"
import script from "./pricingmanagement.vue?vue&type=script&lang=js"
export * from "./pricingmanagement.vue?vue&type=script&lang=js"
import style0 from "./pricingmanagement.vue?vue&type=style&index=0&id=51bd9c57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd9c57",
  null
  
)

export default component.exports